import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-role-selector',
  templateUrl: './role-selector.component.html',
  styleUrls: ['./role-selector.component.scss'],
  standalone: false,
})
export class RoleSelectorComponent {
  @Input() selectedRole: string = 'particulier';
  @Output() roleSelected = new EventEmitter<string>();

  constructor() {}

  handleRoleSelection(role: string) {
    this.selectedRole = role;
    this.roleSelected.emit(role);
  }
} 